export const dataSourcesTabsNames = {
	gnb: 'GNB Configuration Files',
};
